<template>
  <div id="MainRegisterVendor">
    <v-stepper v-model="stepIndex" alt-labels>
      <v-stepper-header>
        <v-stepper-step step="1"
          ><p class="text-center">General Info</p></v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step step="2"
          ><p class="text-center">Bidding Categories</p>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3"
          ><p class="text-center">Location Support</p></v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step step="4"
          ><p class="text-center">Contact Information</p></v-stepper-step
        >
        <v-divider></v-divider>
        <v-stepper-step step="5"
          ><p class="text-center">Attachment</p></v-stepper-step
        >
      </v-stepper-header>

      <v-stepper-items>
        <v-stepper-content
          :step="item.step"
          v-for="(item, index) in steps"
          :key="index"
        >
          <div
            class="pb-16"
            :is="item.component"
            @EmitDataInfo="getDataInfo"
            @EmitCategory="callBackPushCategory"
            @EmitLocation="callBackPushLocation"
            @EmitDataContact="callBackgetDataContact"
            @EmitSubmitAttachment="callBackSubmitAttachment"
            @EmitDescModel="callBackDataFromAttachmentComponent"
            @EmitCategoryNext="callBackCategoryNext"
            @EmitLocationNext="callBackLocationNext"
            @EmitComment="callBackComment"
            @EmitSubmitAttachmentNext="callBackSubmitAttachmentNext"
            :propProvince="province"
            :propCountry="country"
            :formType="formType"
            :propCheckStep="checkStep"
            :propType="type"
            :propUserName="userName"
            :propVendorID="vendorId"
            :propVendorCatListModel="vendorCatListModel"
            :propVendorLocationList="vendorLocationList"
            :propsGulfContactPoint="gulfContactPoint"
            :propRegisterModel="registerModel"
            :propAttachment="attachmentsOldFile"
            :propAttachmentDescription="descriptionModel"
            :propVendorType="vendorType"
          ></div>

          <!-- <v-card class="mb-12" color="grey lighten-1" height="200px" ></v-card> -->
          <v-btn color="primary" @click.prevent="onNextStep(item.step)">
            <!-- <v-btn color="primary" @click="stepIndex = item.step + 1"> -->
            {{ item.step === 5 ? "Submit" : "Next" }}
          </v-btn>
          <v-btn v-show="item.step > 1" @click="stepIndex = item.step - 1" text>
            Back
          </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
import GeneralInfoComponent from "./GeneralInfo";
import { masterservice } from "../../services/masterservice";
import { vendorservice } from "../../services/vendorservice";
export default {
  name: "MainRegisterVendor",
  components: {
    GeneralInfoComponent,
    BiddingCategoriesComponent: () => import("./Category"),
    LocationSupportComponent: () => import("./LocationSupport"),
    ContactInfomationComponent: () => import("./ContactInfomation"),
    AttachedFileComponent: () => import("./AttachedFile"),
  },
  data: () => ({
    steps: [
      {
        icon: "icon-user",
        name: "General Info",
        component: "GeneralInfoComponent",
        step: 1,
      },
      {
        icon: "icon-package",
        name: "Bidding Categories",
        component: "BiddingCategoriesComponent",
        step: 2,
      },
      {
        icon: "icon-map",
        name: "Location Support",
        component: "LocationSupportComponent",
        step: 3,
      },
      {
        icon: "icon-book-open",
        name: "Contact Information",
        component: "ContactInfomationComponent",
        step: 4,
      },
      {
        icon: "icon-file-plus",
        name: "Attachment",
        component: "AttachedFileComponent",
        step: 5,
      },
    ],
    stepIndex: 1,
    province: [],
    country: [],
    checkStep: "",
    userName: "",
    dataInfo: {},
    vendorCatListModel: [],
    vendorLocationList: [],
    gulfContactPoint: [],
    vendorId: 0,
    dataContact: {
      companyContactPointTel: "",
      companyContactPoint: "",
      companyToEmail: "",
      companyCcEmail: "",
      gulfContactPointId: 0,
      others: "",
    },
    attachmentModel: [],
    comment: "",
    dataDataFromAttachment: {},
    descriptionModel: {
      RegisteredCapital: 0,
      ExperienceIn: "",
      ExperienceYear: 0,
      ISOName: "",
      LicenseName: "",
    },
    registerModel: {},
    attachmentsOldFile: [],
    vendorType: "",
  }),
  props: {
    formType: {
      type: String,
      default: "Register",
    },
  },

  async mounted() {
    this.$loading(true);
    this.country = await masterservice.GetMasterCountry();
    this.province = await masterservice.GetMasterProvince();
    this.gulfContactPoint = await masterservice.GetContactPoint();
    if (this.formType === "Edit") {
      await this.getVendorInfo();
    }
    this.$loading(false);
  },
  computed: {
    type() {
      if (this.dataInfo.commercialTypeId === 1) return "1";
      else {
        if (
          this.dataInfo.commercialTypeId === 3 ||
          this.dataInfo.commercialTypeId === 4
        )
          return "3";
        return "2";
      }
    },
    isLoggedIn: function () {
      return this.$store.getters.isLoggedIn;
    },
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    async onNextStep(step) {
      this.checkStep = "";
      setTimeout(() => {
        this.checkStep = step;
      }, 100);
      if (this.formType === "Edit") {
        if (step === 1) {
          this.$loading(true);
          const vendorCategory = await this.getCatVendorList();
          for (let i = 0; i < vendorCategory.length; i++) {
            this.callBackPushCategory({
              TypeEvent: "add",
              model: vendorCategory[i],
            });
          }
          this.$loading(false);
        }
        if (step === 2) {
          this.$loading(true);
          const vendorLocation = await this.getLocation();
          for (let j = 0; j < vendorLocation.length; j++) {
            this.callBackPushLocation({
              TypeEvent: "add",
              model: vendorLocation[j],
            });
          }
          this.$loading(false);
        }
        if (step === 4) {
          this.$loading(true);
          this.attachmentsOldFile = await this.getAttachment();
          await this.getAttachmentDescription();
          this.$loading(false);
        }
      }
    },
    async getVendorInfo() {
      const vendorInfo = await vendorservice.GetVendorInfo(
        this.activeUserInfo.vendorID
      );
      this.vendorId = vendorInfo.vendorId;
      this.userName = vendorInfo.taxId;
      this.vendorType = vendorInfo.vendorType;
      this.registerModel = { ...vendorInfo };
    },
    async getAttachment() {
      return await vendorservice.GetVendorAttachment(
        this.activeUserInfo.userName
      );
    },
    async getCatVendorList() {
      return await vendorservice.GetVendorCategory(
        this.userName,
        this.vendorId
      );
    },
    async getLocation() {
      return await vendorservice.GetVendorLocation(
        this.userName,
        this.vendorId
      );
    },
    async getAttachmentDescription() {
      let val = await vendorservice.GetVendorInfo(this.activeUserInfo.vendorID);

      // Set description model
      this.descriptionModel.RegisteredCapital = parseFloat(
        val.registeredCapital
      );
      this.descriptionModel.ExperienceIn = val.experienceIn;
      this.descriptionModel.ExperienceYear = parseFloat(val.experienceYear);
      this.descriptionModel.ISOName = val.isoname;
      this.descriptionModel.LicenseName = val.licenseName;
      return val;
    },
    getDataInfo(value) {
      this.dataInfo = { ...value };
      this.dataInfo.fxrate = value.fxrate.toString();
      this.vendorId = value.vendorId;
      this.vendorType = value.vendorType;
      if (value.vendorType === "domestic") {
        if (value.taxId) {
          const txtId = value.taxId;
          if (txtId.length >= 13) {
            this.userName =
              value.branchId !== ""
                ? value.taxId + value.branchId
                : value.taxId + "00000";
          }
        }
      } else {
        if (this.formType === "Register") {
          this.userName = "9999999999999";
          this.dataInfo.taxId = "9999999999999";
        }
      }
      this.stepIndex = this.stepIndex + 1;
    },
    callBackgetDataContact(value) {
      this.dataContact.companyContactPointTel = value.companyContactPointTel;
      this.dataContact.companyContactPoint = value.companyContactPoint;
      this.dataContact.companyToEmail = value.companyToEmail;
      this.dataContact.companyCcEmail = value.companyCcEmail;
      this.dataContact.gulfContactPointId = value.gulfContactPointId;
      this.dataContact.others = value.others;
      this.stepIndex = this.stepIndex + 1;
    },
    callBackPushCategory({ TypeEvent, model, categoryId, subCategoryId }) {
      if (TypeEvent === "add") {
        const isDuplicate = this.vendorCatListModel.some(item => 
          item.categoryId === model.categoryId && 
          item.subCategoryId === model.subCategoryId
        );
        
        if (!isDuplicate) {
          this.vendorCatListModel.push(model);
        }
      } else if (TypeEvent === "update") {
        const index = this.vendorCatListModel.findIndex(item => 
          item.categoryId === categoryId && 
          item.subCategoryId === subCategoryId
        );
        
        if (index !== -1) {
          this.vendorCatListModel[index].isActive = true;
          this.vendorCatListModel = [...this.vendorCatListModel];
        }
      } else {
        const index = this.vendorCatListModel.findIndex(item => 
          item.categoryId === categoryId && 
          item.subCategoryId === subCategoryId
        );
        
        if (index !== -1) {
          this.vendorCatListModel[index].isActive = false;
          this.vendorCatListModel = [...this.vendorCatListModel];
        }
      }
    },
    callBackPushLocation({ TypeEvent, model, countryId, provinceId }) {
      if (TypeEvent === "add") {
        const isDuplicate = this.vendorLocationList.some(item => 
          item.countryId === model.countryId && 
          item.provinceId === model.provinceId
        );
        
        if (!isDuplicate) {
          this.vendorLocationList.push(model);
        }
      } else if (TypeEvent === "update") {
        const index = this.vendorLocationList.findIndex(item => 
          item.countryId === countryId && 
          item.provinceId === provinceId
        );
        
        if (index !== -1) {
          this.vendorLocationList[index].isActive = true;
          this.vendorLocationList = [...this.vendorLocationList];
        }
      } else {
        const index = this.vendorLocationList.findIndex(item => 
          item.countryId === countryId && 
          item.provinceId === provinceId
        );
        
        if (index !== -1) {
          this.vendorLocationList[index].isActive = false;
          this.vendorLocationList = [...this.vendorLocationList];
        }
      }
    },
    async callBackCategoryNext() {
      this.stepIndex = this.stepIndex + 1;
      this.country = await masterservice.GetMasterCountry();
      this.province = await masterservice.GetMasterProvince();
    },
    callBackLocationNext() {
      this.stepIndex = this.stepIndex + 1;
    },
    callBackComment(val) {
      this.comment = val;
    },
    callBackSubmitAttachment(val) {
      this.attachmentModel = val;
    },
    callBackDataFromAttachmentComponent(val) {
      this.dataDataFromAttachment.registeredCapital = parseFloat(
        val.RegisteredCapital
      );
      this.dataDataFromAttachment.experienceIn = val.ExperienceIn;
      this.dataDataFromAttachment.experienceYear = parseFloat(
        val.ExperienceYear
      );
      this.dataDataFromAttachment.isoname = val.ISOName;
      this.dataDataFromAttachment.licenseName = val.LicenseName;
    },
    async callBackSubmitAttachmentNext() {
      // this.$loading(true);
      // if (await this.checkAndSetFile()) {
      const dataModel = { ...this.dataInfo };
      dataModel.numberofEmployees = parseInt(dataModel.numberofEmployees);
      dataModel.companyTurnOver = dataModel.companyTurnOver
        ? parseFloat(dataModel.companyTurnOver.replace(/,/g, ""))
        : null;
      dataModel.registeredCapital = dataModel.registeredCapital
        ? parseFloat(dataModel.registeredCapital)
        : null;
      let ArrCate = [];
      let ArrLocation = [];
      for (let i = 0; i < this.vendorCatListModel.length; i++) {
        const modelCateForAPI = {
          id: this.vendorCatListModel[i].id,
          vendorId: this.vendorId,
          userName: this.userName,
          categoryId: this.vendorCatListModel[i].categoryId,
          subCategoryId: this.vendorCatListModel[i].subCategoryId,
          isActive: this.vendorCatListModel[i].isActive,
        };
        ArrCate.push(modelCateForAPI);
      }
      for (let j = 0; j < this.vendorLocationList.length; j++) {
        const modelLocationForAPI = {
          id: this.vendorLocationList[j].id,
          vendorId: this.vendorId,
          userName: this.userName,
          countryId: this.vendorLocationList[j].countryId,
          provinceId: this.vendorLocationList[j].provinceId,
          isActive: this.vendorLocationList[j].isActive,
        };
        ArrLocation.push(modelLocationForAPI);
      }
      dataModel.companyContactPointTel =
        this.dataContact.companyContactPointTel;
      dataModel.companyContactPoint = this.dataContact.companyContactPoint;
      dataModel.companyToEmail = this.dataContact.companyToEmail;
      dataModel.companyCcEmail = this.dataContact.companyCcEmail;
      dataModel.gulfContactPointId = this.dataContact.gulfContactPointId;
      dataModel.others = this.dataContact.others;

      dataModel.registeredCapital = this.dataDataFromAttachment
        .registeredCapital
        ? parseFloat(this.dataDataFromAttachment.registeredCapital)
        : null;
      dataModel.experienceIn = this.dataDataFromAttachment.experienceIn;
      dataModel.experienceYear = this.dataDataFromAttachment.experienceYear
        ? parseFloat(this.dataDataFromAttachment.experienceYear)
        : null;
      dataModel.isoname = this.dataDataFromAttachment.isoname;
      dataModel.licenseName = this.dataDataFromAttachment.licenseName;

      let resultModel = {
        ...dataModel,
        categories: ArrCate,
        locations: ArrLocation,
        comment: this.comment,
      };
      if (this.formType === "Register") this.connectApiRegister(resultModel);
      if (this.formType === "Edit") this.connectApiUpdate(resultModel);
      // } else {
      //   this.$loading(false);
      // }
    },
    async checkAndSetFile() {
      let validate = true;
      if (this.attachmentModel.length > 0) {
        for (let i = 0; i < this.attachmentModel.length; i++) {
          if (this.attachmentModel[i].isNewFile) {
            let form = new FormData();
            form.append("UserName", this.activeUserInfo.userName || this.userName);
            form.append("VendorId", this.attachmentModel[i].VendorId);
            form.append("File", this.attachmentModel[i].File);
            form.append(
              "AttachmentType",
              this.attachmentModel[i].AttachmentType
            );

            if (
              this.attachmentModel[i].AttachmentType == "TurnoverDatingYear1"
            ) {
              form.append("currency", this.attachmentModel.currency1);
              form.append("fxrate", this.attachmentModel.fxrate1);
              form.append("thbath", this.attachmentModel.thbath1);
              form.append(
                "companyTurnOver",
                this.attachmentModel.companyTurnOver1
              );
              form.append("year", this.attachmentModel.year1year);
            }

            if (
              this.attachmentModel[i].AttachmentType == "TurnoverDatingYear2"
            ) {
              form.append("currency", this.attachmentModel.currency2);
              form.append("fxrate", this.attachmentModel.fxrate2);
              form.append("thbath", this.attachmentModel.thbath2);
              form.append(
                "companyTurnOver",
                this.attachmentModel.companyTurnOver2
              );
              form.append("year", this.attachmentModel.year2year);
            }

            if (
              this.attachmentModel[i].AttachmentType == "TurnoverDatingYear3"
            ) {
              form.append("currency", this.attachmentModel.currency3);
              form.append("fxrate", this.attachmentModel.fxrate3);
              form.append("thbath", this.attachmentModel.thbath3);
              form.append(
                "companyTurnOver",
                this.attachmentModel.companyTurnOver3
              );
              form.append("year", this.attachmentModel.year3year);
            }

            form.append(
              "Description",
              this.attachmentModel[i].Description === undefined
                ? ""
                : this.attachmentModel[i].Description
            );
            form.append(
              "ExpireDate",
              this.attachmentModel[i].ExpireDate === undefined
                ? ""
                : this.attachmentModel[i].ExpireDate
            );
            try {
              const result = await vendorservice.SubmitFileVendor(form);
              this.$loading(false);
              if (result.message !== undefined) {
                this.$notify({
                  type: "error",
                  title: "Can't Save Bidding Attachment",
                  text: `${result.message}`,
                });
                return;
              }
            } catch (error) {
              this.$loading(false);
              this.$notify({
                type: "error",
                title: "Can't Save Bidding Attachment",
                text: `System Error :${error}`,
              });
              return;
            }
          } else {
            if (this.formType === "Edit") {
              if (
                this.attachmentModel[i].AttachmentType === "IdCard" ||
                this.attachmentModel[i].AttachmentType === "Affidavit" ||
                this.attachmentModel[i].AttachmentType === "ListOfShareholders" ||
                this.attachmentModel[i].AttachmentType == "TurnoverDatingYear1" ||
                this.attachmentModel[i].AttachmentType == "TurnoverDatingYear2" ||
                this.attachmentModel[i].AttachmentType == "TurnoverDatingYear3"
              ) {
                let form = new FormData();
                form.append("UserName", this.activeUserInfo.userName || this.userName);
                form.append("VendorId", this.attachmentModel[i].VendorId);
                form.append(
                  "AttachmentType",
                  this.attachmentModel[i].AttachmentType
                );
                form.append(
                  "Description",
                  this.attachmentModel[i].Description
                    ? this.attachmentModel[i].Description
                    : ""
                );
                form.append(
                  "ExpireDate",
                  this.attachmentModel[i].ExpireDate
                    ? this.attachmentModel[i].ExpireDate
                    : ""
                );

                if (
                  this.attachmentModel[i].AttachmentType === "TurnoverDatingYear1"
                ) {
                  form.append("currency", this.attachmentModel.currency1);
                  form.append("fxrate", this.attachmentModel.fxrate1);
                  form.append("thbath", this.attachmentModel.thbath1);
                  form.append(
                    "companyTurnOver",
                    this.attachmentModel.companyTurnOver1
                  );
                  form.append("year", this.attachmentModel.year1year);
                } else if (
                  this.attachmentModel[i].AttachmentType === "TurnoverDatingYear2"
                ) {
                  form.append("currency", this.attachmentModel.currency2);
                  form.append("fxrate", this.attachmentModel.fxrate2);
                  form.append("thbath", this.attachmentModel.thbath2);
                  form.append(
                    "companyTurnOver",
                    this.attachmentModel.companyTurnOver2
                  );
                  form.append("year", this.attachmentModel.year2year);
                } else if (
                  this.attachmentModel[i].AttachmentType === "TurnoverDatingYear3"
                ) {
                  form.append("currency", this.attachmentModel.currency3);
                  form.append("fxrate", this.attachmentModel.fxrate3);
                  form.append("thbath", this.attachmentModel.thbath3);
                  form.append(
                    "companyTurnOver",
                    this.attachmentModel.companyTurnOver3
                  );
                  form.append("year", this.attachmentModel.year3year);
                }

                try {
                  const result = await vendorservice.SubmitFileVendor(form);
                  if (result.message) {
                    this.$notify({
                      type: "error",
                      title: "Can't Save Bidding Attachment",
                      text: `${result.message}`,
                    });
                    this.$loading(false);
                    return;
                  }
                } catch (error) {
                  this.$notify({
                    type: "error",
                    title: "Can't Save Bidding Attachment",
                    text: `System Error :${error}`,
                  });
                  this.$loading(false);
                  return;
                }
              }
            }
          }
        }
      }
      return validate;
    },
    async connectApiUpdate(data) {
      console.log("data", data);

      try {
        this.$loading(true);
        let result = await vendorservice.UpdateVendorInfo(data);
        if (result.message == undefined) {
          if (await this.checkAndSetFile()) {
            this.$notify({
              type: "success",
              title: "Update Success",
              text: "Please waiting for confirmation email",
            });
            // Redirect to Login page
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          }
          this.$loading(false);
        } else {
          this.$loading(false);
          this.$notify({
            type: "warning",
            title: "Update failed",
            text: result.message,
          });
        }
      } catch (error) {
        this.$loading(false);
        this.$notify({
          type: "error",
          title: "Register failed",
          text: `System Error : [${error}]`,
        });
      }
    },
    async connectApiRegister(data) {
      try {
        this.$loading(true);
        let result = await vendorservice.Register(data);
        if (result.message === undefined) {
          this.userName = result.taxId + result.branchId;
          this.attachmentModel.map((e) => (e.VendorId = result.vendorId));
          if (await this.checkAndSetFile()) {
            this.$notify({
              type: "success",
              title: "Register Success",
              text: "Thank you for you registration, Please waiting for confirmation email",
            });
            setTimeout(() => {
              this.$router.push(`/login`).catch(() => {});
            }, 1000);
          }
          this.$loading(false);
        } else {
          this.$loading(false);
          if (result.message == "Register Error This company already exist") {
            this.$notify({
              type: "warning",
              title: "Register failed",
              text: "This TaxID already exist",
            });
          } else {
            this.$notify({
              type: "warning",
              title: "Register failed",
              text: result.message,
            });
          }
        }
      } catch (error) {
        this.$loading(false);
        this.$notify({
          type: "warning",
          title: "Register failed",
          text: `System Error : [${error}]`,
        });
      }
    },
  },
};
</script>

<style></style>
